import { render, staticRenderFns } from "./Receipt-products.vue?vue&type=template&id=191cf832"
import script from "./Receipt-products.vue?vue&type=script&lang=js"
export * from "./Receipt-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports